export default "__VITE_ASSET__BaNFwWV4__"